<template>
  <div>
    <a-select
      option-filter-prop="title"
      :mode="multiple ? 'multiple' : undefined"
      :placeholder="placeholder"
      :value="value"
      allow-clear
      class="w100"
      :class="class"
      :disabled="disabled"
      show-search
      @change="onChange"
      @clear="onClear"
      @select="onSelect"
    >
      <a-select-option
        v-for="item in options"
        :key="item.id"
        :value="item.id"
        :title="item.realName"
        :disabled="item.disabled"
      >
        {{ item.realName }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { HttpService } from "@/core";
import { AxiosResponse } from "axios";
import { ResponseResp } from "@/core/interface";
import {
  UserSimpleListResp,
  UserSimpleRecord,
  UserSimpleListReq,
} from "./user-search-select.interface";

export default defineComponent({
  isGlobal: true,
  name: "UserSearchSelect",
  props: {
    value: { type: [String, Array], default: undefined },

    multiple: { type: Boolean, default: false },

    placeholder: { type: String, default: "请选择" },
    activatedStatus: {
      type: Number,
      default: undefined,
    },
    status: {
      type: Number,
      default: undefined,
    },
    onJob: {
      type: Boolean,
      default: undefined,
    },
    userState:{
      type: String,
      default: "",
    },
    class: {
      type: String,
      default: "append-to-parent",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emit: ["update:value", "change", "clear", "select"],
  setup(props, { emit }) {
    const state = reactive<{
      loading: boolean;
      options: UserSimpleRecord[];
      params: UserSimpleListReq;
    }>({
      loading: false,
      options: [],
      params: new UserSimpleListReq(),
    });

    const onChange = (value) => {
      emit("update:value", value);
      emit("change", value);
    };

    const onClear = () => {
      if (props.multiple) {
        emit("update:value", []);
        emit("clear", []);
      } else {
        emit("update:value", undefined);
        emit("clear", undefined);
      }
    };

    const onSelect = (key) => {
      const user = state.options.find((item) => item.id === key);
      emit("select", user);
    };

    onMounted(async () => {
      state.params.activatedStatus =props.activatedStatus==0?undefined:1;
      state.params.status = 1;
      state.params.onJob = true;
      state.params.state = props.userState
      state.params.staffType = "no_type"
      const r: AxiosResponse<ResponseResp<UserSimpleListResp>> = await HttpService.axios({
        method: "GET",
        url: "/tenant_user/simple/list",
        params: state.params,
      });
      const res = r.data;
      // console.log(res,'res,dadad')
      if (res.respCode === "0000") {
        state.options = (res.data?.records || []).map((item) => {
          item.disabled = false;
          return item;
        });
      }
    });

    return {
      ...toRefs(state),
      onChange,
      onClear,
      onSelect,
    };
  },
});
</script>
